//
import EmployeeModel from '@/models/HumanResource/HrEmployee'

/**
 * @description
 * Employee Loan Company Filters
 * 
 * hr_employee_id	Si	Int	ID del empleado
 * 
 * @type	{array}
 */
export default [
    {
        name: 'hr_employee_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Empleado',
            model: EmployeeModel,
            noObject: true,
            paramSearch: 'names',
        },
    },
]
